import React from "react";
import Header8 from "./../Common/Header8";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import About5 from "./../Elements/About5";
import WhatWeDo3 from "./../Elements/WhatWeDo3";
import Statistics1 from "./../Elements/Statistics1";
import Team1 from "./../Elements/Team1";
import ClientsLogo1 from "./../Elements/ClientsLogo1";

var bnrimg = require("../../images/banner/banner.jpg")


class Home4 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    return (
      <>
        <Header8 />
        <div className="page-content">
          <Banner
            parent="A Propos"
            title="Organisation"
            pagename="Organisation"
            bgimage={bnrimg}
          />
          <About5 />
        </div>

        <Footer />
      </>
    );
  }
}

export default Home4;
